fx.ns("shared", class EditorHistory extends fx.History {

    constructor(model)
    {
        super(model);
    }

    get currentPage()
    {
        return this._currentPage;
    }

    set currentPage(val)
    {
        this._currentPage = val;
    }

    get mode()
    {
        return this._mode;
    }

    set mode(val)
    {
        this._mode = val;
    }

    valid(action)
    {
        if (!super.valid(action))
            return false;

        if (action.type == "update" && action.model instanceof models.Zoom)
        {
            if (action.data.value > 100 || action.previous.value > 100 || action.impacts("x") || action.impacts("y") || ( action.data.value == action.previous.value))
                return false;
        } 
            
        if (action.tag == "fill" || action.tag == "resize-text")
            return false;

        if (action.model && (action.model instanceof models.CreationElementContent && action.data && action.data.content && action.previous.content))
        {
            if (Utils.isID(action.previous.content) && !Utils.isID(action.data.content) && Object.keys(action.previous).length == 1 &&  Object.keys(action.data).length == 1)
                return false;
        }

        if (action.model && action.model instanceof models.Zoom && action.type == "create")
            return false;
        
        if (action.model && action.model instanceof models.Photo && action.impacts("hash"))
            return false;

        if (action.model && action.model instanceof models.Photo && action.type == "update" && action.impacts("deleted"))
            return (!action.model._upload || action.model._upload.uploaded);
        
        if (action.type == "update" && (action.model instanceof models.CreationElementContent || action.model instanceof models.ProductBookPage || action.model instanceof models.Photo))
        {
            if (action.impactsOnly("id") || action.impactsOnly("creation_element_id"))
                return false;
        }

        //----- Print
        if (action.type == "update" && action.model instanceof models.ProductPrintPage)
            return !action.impactsOnly("id");

        if (action.type == "delete" && action.model instanceof models.ProductPrintPage)
            return true;

        if (action.type == "removeItem" && action.model && (action.model.parentModel instanceof models.ProductPrintPage || action.model.parentModel instanceof models.ProductPrint))
            return true;

        // a print added to the creation too : without it, undoing an added print only removed its photo
        // and background and left the page, blank and later renumbered in place (creation 4411255)
        if (action.type == "addItemAt" && action.model && (action.model.parentModel instanceof models.ProductPrintPage || action.model.parentModel instanceof models.ProductPrint))
            return true;

        //----- Frame
        if (action.type == "update" && action.model instanceof models.CreationElementContent)
            return !action.impactsOnly("id");

        if (action.type == "delete" && action.model instanceof models.CreationElementContent)
            return true;

        if (action.type == "removeItem" && action.model && (action.model.parentModel instanceof models.CreationElement || action.model.parentModel instanceof models.ProductFrame))
            return true;

        if (action.type == "addItemAt" && action.model && (action.model.parentModel instanceof models.CreationElement))
            return true;

        // ------- Book
         if (action.model && (action.model.parentModel instanceof models.ProductBookPage  || action.model.parentModel instanceof models.ProductBook))
            return true;

        if (action.model && (action.model instanceof models.CreationElementContent || action.model instanceof models.ProductBookPage || action.model instanceof models.Zoom))
            return true;

        // ------ Photo
        if (action.model && action.model instanceof models.Photo && action.impacts("number"))
            return true;
    }

    undo()
    {
        if (this.model.zoom.value == 100 && !this._actionOnCurrentPage( this.currentAction ) )
            return;

        this._checkTemporaryId(this.currentAction);
        
        super.undo();
    }

    redo()
    {
        if (this.model.zoom.value == 100 && !this._actionOnCurrentPage( this._actions[this._position + 1] ) )
            return;

        this._checkTemporaryId(this._actions[this._position + 1]);
        
        super.redo();
    }

    needMerge(lastAction, action)
    {
        if (!lastAction)
            return false;

        // let's merge all consecutive text editions
        if (lastAction.model instanceof models.CreationElementContent && action.model instanceof models.CreationElementContent && lastAction.model == action.model)
        {
            if (lastAction.model.isText && action.model.isText)
            {
                if (lastAction.data && lastAction.data.content && action.data && action.data.content)
                        return true;
            }
        }

        return super.needMerge(lastAction, action);
    }

    _checkTemporaryId(group)
    {
        if (!group) return;
        
        for (let i = 0; i < group.actions.length; i++)
        {
            let action = group.actions[i];
            if (action.properties.indexOf("content") !=-1)
            {
                let id = Utils.temporaryId(action.data.content);
                if (id)
                    action.data.content = id;

                id = Utils.temporaryId(action.previous.content);
                if (id)
                    action.previous.content = id;
            }
            
            if (action.data instanceof models.CreationElementContent && action.data.isPhoto && Utils.isID(action.data.content) && Utils.temporaryId(action.data.content))
            {
                let update = new fx.Action("update", {content : Utils.temporaryId(action.data.content)}, action.data, "", true);
                action.data.update(update);
            }
            
            if (action.model instanceof models.CreationElementContent && action.model.isPhoto && Utils.isID(action.model.content) && Utils.temporaryId(action.model.content))
            {
                let update = new fx.Action("update", {content : Utils.temporaryId(action.model.content)}, action.model, "", true);
                action.model.update(update);
            }
            
        }
    }

    _actionOnCurrentPage(group)
    {
        if (!group) return true;

         let currentPage;
         for (let i = 0; i < group.actions.length; i++)
         {
            let action = group.actions[i];

             if (action.type == "create")
                 continue;
 
            
            let page;
            if (action.data instanceof models.ProductBookPage || action.model instanceof models.ProductBookPage)
                page = action.data instanceof models.ProductBookPage ? action.data : action.model;
            else
            if (action.data instanceof models.CreationElementContent || action.model instanceof models.CreationElementContent)
            {
                let component = action.data instanceof models.CreationElementContent ? action.data : action.model;
                page = component.parentModel
                while (page && !(page instanceof models.ProductBookPage))
                    page = page.parentModel;
            }

            if (!page) return true;

 
            if(page)
            {
                 if (!currentPage)
                     currentPage = page;
                 else
                 if (currentPage != page) 
                     return true;
            }
         }

         if (!currentPage)
            return true;

         
        for (let i = 0; i < group.actions.length; i++)
        {
            let action = group.actions[i];
            
            if (action.type == "create")
                continue;

            if (action.model instanceof fx.ModelArray && action.data instanceof models.ProductBookPage) // addItem(At) & removeItem(At)
            {
                let index;
                if (action.type == "removeItem" || action.type == "removeItemAt" && action.index)
                    index = action.index;
                else
                    index = this.model.creation.elements.indexOf( action.data ) - 1;

                let element = this.model.creation.elements.getItemAt( index || 1 );
                if (element && element != this._currentPage)
                {
                    this._currentPage = element;
                    this.trigger("currentPage-updated", group.side);
                    // switch to page
                    return false;
                }
                else
                    return true;
            }

            let page = action.model;

            while(page && !(page instanceof models.ProductBookPage))
                page = page.parentModel;

            if (this.mode == "editor")
            {
                // check if update is on same page
                if (page && page != this._currentPage)
                {
                    this._currentPage = page;
                    this.trigger("currentPage-updated");
                    // switch to page
                    return false;
                }
            }
            else // show next page
            {
                return true;
            }
        }

        return true;
    }

});
